export const SET_LOADING = 'src/store/seasonPass/SET_LOADING'
export const SET_SAVE_LOADING = 'src/store/seasonPass/SET_SAVE_LOADING'
export const SET_SEASON_PASS = 'src/store/seasonPass/SET_SEASON_PASS'
export const SET_SEASON_USER = 'src/store/seasonPass/SET_SEASON_USER'
export const SET_SEASON_SEAT = 'src/store/seasonPass/SET_SEASON_SEAT'
export const SET_SEASON_RESPONSE = 'src/store/seasonPass/SET_SEASON_RESPONSE'
export const SET_SEASON_USER_RESPONSE = 'src/store/seasonPass/SET_SEASON_USER_RESPONSE'
